var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSlp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 200,
    height: 200,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#043013",
    fillRule: "evenodd",
    d: "m10.115 6.803l-.358-1.422c.264-.229 1.013-.683 1.899-.666s1.551.291 1.773.427l-.183 1.416h.03C14.272 6.895 18 9.962 18 13.55s-3.325 5.337-6.183 5.306c-2.859-.03-5.967-1.778-5.811-5.674c.114-2.87 2.594-5.303 4.11-6.38",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#55D290",
    d: "M6.434 13.147c.115-2.883 2.818-5.288 4.155-6.13h2.597c.923.313 4.385 3.15 4.385 6.47s-3.087 4.938-5.742 4.91s-5.54-1.645-5.395-5.25"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FBB7CF",
    d: "M7.361 13.747c-.012-1.208.439-2.088.666-2.376l7.75-.27c.262.434.79 1.57.802 2.645c.015 1.345-1.59 3.96-4.707 3.885s-4.496-2.376-4.51-3.885"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FEDEEB",
    d: "M12.023 11.786c2.124 0 3.845-.294 3.845-.656s-1.722-.656-3.845-.656s-3.845.294-3.845.656s1.722.656 3.845.656"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F3FFFA",
    d: "M9.783 8.786c-.52-.024-.994.563-1.287 1.016c-.292.548-.896 1.907 0 1.704s1.423-1.062 1.575-1.465c.12-.408.232-1.23-.288-1.255"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FD93B7",
    d: "M10.267 16.196c-.205-1.052 1.206-2.28 1.937-2.764c.845-.557 3.122-1.024 3.679-.164c.696 1.076-.666 2.57-1.665 3.242c-1 .673-3.694 1.001-3.95-.314"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF8FD",
    d: "M15.783 15.66c-.246-.141-.731.156-.943.323c-.202.134-.535.473-.249.755s.772-.098.954-.274c.199-.242.485-.662.238-.804"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#CFE7E2",
    fillOpacity: 0.8,
    d: "m7.108 14.294l-.4-1.366l.498.6l1.457-1.271l2.282 1.678l2.197-1.918l2.246 1.247l1.13-1.558l.63 1.15l-.63-.73l-1.02 1.737l-2.356-1.187l-2.197 2.085l-2.356-1.833z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#043013",
    d: "M10.877 7.534c-.556-.265-.66-.588-.705-.717c.998-.069 2.988-.165 2.967 0c-.022.165-.455.547-.668.717z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#tokenBrandedSlp0)",
    d: "M11.616 7.916c-1.184-.037-1.415-1.474-1.383-2.188c.14-.231.6-.478 1.383-.524c.626-.037 1.136.334 1.314.524c.055.744-.129 2.225-1.314 2.188"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8FD366",
    d: "M10.792 8.293c-.302-.276-.386-.75-.391-.952c.228.239.827.7 1.397.634s1.132-.505 1.341-.717v.373c-.123.816-.945 1.01-1.341 1.006c-.21 0-.704-.069-1.006-.344"
  }), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "tokenBrandedSlp0",
    x1: 11.999,
    x2: 11.999,
    y1: 6.319,
    y2: 18.858,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F8C74B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.343,
    stopColor: "#F38C34"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSlp);
export default __webpack_public_path__ + "static/media/slp.062323888d4a79acf148a1b7772ba42a.svg";
export { ForwardRef as ReactComponent };